package com.essntl.uikit.theme

import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import androidx.compose.ui.text.TextStyle
import androidx.compose.ui.text.font.FontFamily
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.sp
import com.essntl.uikit.resources.LocalRes
import org.jetbrains.compose.resources.ExperimentalResourceApi
import org.jetbrains.compose.resources.Font

@OptIn(ExperimentalResourceApi::class)
@Composable
internal fun getManropeFontFamily(): FontFamily? {
    val res = LocalRes.current

    return FontFamily(
        Font(
            resource = res.manropeExtraLight,
            weight = FontWeight.ExtraLight,
        ),
        Font(
            resource = res.manropeLight,
            weight = FontWeight.Light,
        ),
        Font(
            resource = res.manropeRegular,
            weight = FontWeight.Normal,
        ),
        Font(
            resource = res.manropeMedium,
            weight = FontWeight.Medium,
        ),
        Font(
            resource = res.manropeSemiBold,
            weight = FontWeight.SemiBold,
        ),
        Font(
            resource = res.manropeBold,
            weight = FontWeight.Bold,
        ),
        Font(
            resource = res.manropeExtraBold,
            weight = FontWeight.ExtraBold,
        ),
    )
}


@Composable
internal fun getTypography(): EsTypography {
    val manropeFontFamily = getManropeFontFamily()

    return remember(manropeFontFamily) {
        EsTypography(
            h1ExtraBold36 = TextStyle(
                fontFamily = manropeFontFamily,
                fontWeight = FontWeight.ExtraBold,
                fontSize = 32.sp,
                lineHeight = 32.sp,
                letterSpacing = (-1.08f).sp,
            ),
            h2Bold32 = TextStyle(
                fontFamily = manropeFontFamily,
                fontWeight = FontWeight.Bold,
                fontSize = 26.sp,
                lineHeight = 26.sp,
                letterSpacing = (-0.96).sp,
            ),
            h3Bold24 = TextStyle(
                fontFamily = manropeFontFamily,
                fontWeight = FontWeight.Bold,
                fontSize = 24.sp,
                lineHeight = 32.sp,
                letterSpacing = (-0.48).sp,
            ),
            h3Regular24 = TextStyle(
                fontFamily = manropeFontFamily,
                fontWeight = FontWeight.Normal,
                fontSize = 20.sp,
                lineHeight = 28.sp,
                letterSpacing = (-0.48).sp,
            ),
            h4SemiBold20 = TextStyle(
                fontFamily = manropeFontFamily,
                fontWeight = FontWeight.SemiBold,
                fontSize = 18.sp,
                lineHeight = 20.sp,
                letterSpacing = (-0.2).sp,
            ),
            s1Bold16 = TextStyle(
                fontFamily = manropeFontFamily,
                fontWeight = FontWeight.Bold,
                fontSize = 16.sp,
                lineHeight = 24.sp,
            ),
            s2SemiBold16 = TextStyle(
                fontFamily = manropeFontFamily,
                fontWeight = FontWeight.SemiBold,
                fontSize = 16.sp,
                lineHeight = 24.sp,
            ),
            p1Bold16 = TextStyle(
                fontFamily = manropeFontFamily,
                fontWeight = FontWeight.Bold,
                fontSize = 16.sp,
                lineHeight = 24.sp,
            ),
            p1Medium16 = TextStyle(
                fontFamily = manropeFontFamily,
                fontWeight = FontWeight.Medium,
                fontSize = 16.sp,
                lineHeight = 24.sp,
            ),
            p1Regular16 = TextStyle(
                fontFamily = manropeFontFamily,
                fontWeight = FontWeight.Normal,
                fontSize = 16.sp,
                lineHeight = 24.sp,
            ),
            p2Medium14 = TextStyle(
                fontFamily = manropeFontFamily,
                fontWeight = FontWeight.Medium,
                fontSize = 14.sp,
                lineHeight = 20.sp,
            ),
            p2Regular14 = TextStyle(
                fontFamily = manropeFontFamily,
                fontWeight = FontWeight.Normal,
                fontSize = 14.sp,
                lineHeight = 20.sp,
            ),
            c1Medium13 = TextStyle(
                fontFamily = manropeFontFamily,
                fontWeight = FontWeight.Medium,
                fontSize = 13.sp,
                lineHeight = 16.sp,
            ),
            c1Medium11 = TextStyle(
                fontFamily = manropeFontFamily,
                fontWeight = FontWeight.Medium,
                fontSize = 11.sp,
                lineHeight = 16.sp,
            ),
            h565018 = TextStyle(
                fontFamily = manropeFontFamily,
                fontWeight = FontWeight(650),
                fontSize = 18.sp,
                lineHeight = 24.sp,
            ),
        )
    }
}
